import React from 'react';
import AssetList from 'components/Asset/AssetList/AssetList';
import _ from 'lodash';
import T from 'localization/LocalizationKeys';
import { useTranslation } from 'localization/useTranslation';
import Icons, { Size } from 'components/Common/Icons';


const AssetListPanel = ({ data }) => {
  const { nodeValues: { isLoading, nodes } } = data;
  const T = useTranslation();
  const assetIds = _.reduce(nodes, (acc, node) => {
    const assets = _.filter(node.assetDescendants, (asset) => asset.type === 'ASSET');
    return [...acc, ...assets];
  }, []);
  if (isLoading) {
    return (<div>{ T.common.loading }</div>);
  }
  return (<AssetList
    assetIds={assetIds}
    baseUrl="/view"
  />);
};
AssetListPanel.properties = {
  nodeValues: {
    type: 'nodes'
  }
};

AssetListPanel.info = {
  label: T.dashboard.panels.types.assetList,
  help: 'panels/assetlist',
  icon: <Icons.Table size={Size.LARGE}/>
};

export default React.memo(AssetListPanel);
